"use client";

import { c as _c } from "react/compiler-runtime";
type LiveBlinkProps = {
  className?: string;
};
export default function LiveBlink(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "mr-2" : t1;
  const t2 = `inline-flex items-center align-middle ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="relative inline-flex h-4 w-4 items-center justify-center"><span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-40 animate-[wave_1.5s_ease-out_infinite]" /><span className="absolute inline-flex h-3 w-3 rounded-full bg-red-500 opacity-60 animate-[wave_1.5s_ease-out_0.3s_infinite]" /><span className="relative inline-flex h-2 w-2 rounded-full bg-red-600" /></span>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <span className={t2}>{t3}</span>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}